import Rating from 'react-star-rating-component'

export default Rating
